(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_main_product"] && !Shopify.designMode) return;
  try {
    
    if (window.hasLiningTag === true) {
        $(document).ready(function() {
          $('.custom_main_product_usefulllink').html('<div class="usefulllink_content"><p>**Prices are per panel, not per pair</p></div>');
          $("a[href='/products/blackout-drapes-lining'][title='Upgrade to Blackout Lining']").remove();
          $("label:contains('HEADING STYLE')").text("CURTAIN STYLE");
          $("label:contains('SELECT LINING')").text("LINING COLOR");
          $("label:contains('PANEL LENGTH (CMS)')").text("CURTAIN LENGTH (Inches)");
          $("label:contains('PANEL WIDTH (CMS)')").text("CURTAIN WIDTH (Inches)");
          $("input.selected-option[data-head='Select PANEL LENGTH']").val("Select LENGTH");
          $("input.selected-option[data-head='Select PANEL WIDTH']").val("Select WIDTH");
          $("input.selected-option[data-head='SELECT LINING']").val("SELECT COLOR");
          $("span:contains('Measurement Tips')").parent().parent().remove();
          $(".custom_main_product_freesample").contents().not("a").remove();
          $(".custom_main_product_freesample").css("visibility", "hidden");
      });    
    }
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_runner_product"] && !Shopify.designMode) return;
  try {
    
    if (window.hasLiningTag === true) {
        $(document).ready(function() {
          $('.custom_main_product_usefulllink').html('<div class="usefulllink_content"><p>**Prices are per panel, not per pair</p></div>');
          $("a[href='/products/blackout-drapes-lining'][title='Upgrade to Blackout Lining']").remove();
          $("label:contains('HEADING STYLE')").text("CURTAIN STYLE");
          $("label:contains('SELECT LINING')").text("LINING COLOR");
          $("label:contains('PANEL LENGTH (CMS)')").text("CURTAIN LENGTH (Inches)");
          $("label:contains('PANEL WIDTH (CMS)')").text("CURTAIN WIDTH (Inches)");
          $("input.selected-option[data-head='Select PANEL LENGTH']").val("Select LENGTH");
          $("input.selected-option[data-head='Select PANEL WIDTH']").val("Select WIDTH");
          $("input.selected-option[data-head='SELECT LINING']").val("SELECT COLOR");
          $("span:contains('Measurement Tips')").parent().parent().remove();
          $(".custom_main_product_freesample").contents().not("a").remove();
          $(".custom_main_product_freesample").css("visibility", "hidden");
      });    
    }
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
